import { HoaFeeDto } from "@cma/shared/apis/comps/cma/generated";
import { Listing } from "../types/Listing";

type SummarizedListing = {
  id: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  neighborhood: string;
  zipCode: string;
  bedroomCount: number; // Fix
  numBedrooms: number;
  bathroomCount: number; // Fix
  numBathrooms: number;
  currentPrice: number;
  internalSize: number;
  lotSize: number;
  costPerInternalSqFt: number;
  listDate: string;
  hoaMonthlyFee: number;
  hoaFee?: HoaFeeDto;
  propertyType: string;
  listingStatus: string;
  lastSourceUpdateDate: string;
  soldPrice: number;
  listPrice: number;
  hasDoormanAttendance: boolean;
  isLease: boolean;
  // photos: string[]; --- IGNORE ---
  uPropertyId: string;
  yearBuilt: number;
  // link: string; --- IGNORE ---
  // description?: string; --- IGNORE ---
  // agents?: {
  //   name?: string | null;
  //   brokerage?: string | null;
  //   lastSourceUpdateDate?: string | null;
  // }[]; --- IGNORE ---
  // unitCount?: number; --- IGNORE ---
  latitude?: number;
  longitude?: number;
  mlsId: string;
  mlsSource: string;
  county?: string;
  parkingGarageSpaces?: number;
};

export const convertListingToSummarizedListing = (
  listing: Listing
): SummarizedListing => {
  return {
    id: listing.id,
    addressLine1: listing.addressLine1,
    addressLine2: listing.addressLine2,
    city: listing.city,
    state: listing.state,
    neighborhood: listing.neighborhood,
    zipCode: listing.zipCode,
    bedroomCount: listing.bedroomCount,
    numBedrooms: listing.numBedrooms,
    bathroomCount: listing.bathroomCount,
    numBathrooms: listing.numBathrooms,
    currentPrice: listing.currentPrice,
    internalSize: listing.internalSize,
    lotSize: listing.lotSize,
    costPerInternalSqFt: listing.costPerInternalSqFt,
    listDate: listing.listDate,
    hoaMonthlyFee: listing.hoaMonthlyFee,
    hoaFee: listing.hoaFee,
    propertyType: listing.propertyType?.propertyType ?? "Unknown",
    listingStatus: listing.listingStatus?.listingStatus ?? "Unknown",
    lastSourceUpdateDate: listing.lastSourceUpdateDate,
    soldPrice: listing.soldPrice,
    listPrice: listing.listPrice,
    hasDoormanAttendance: listing.hasDoormanAttendance,
    isLease: listing.isLease,
    uPropertyId: listing.uPropertyId,
    yearBuilt: listing.yearBuilt,
    latitude: listing.latitude,
    longitude: listing.longitude,
    mlsId: listing.mlsId,
    mlsSource: listing.mlsSource,
    county: listing.county,
    parkingGarageSpaces: listing.parkingGarageSpaces,
  };
};
